module.exports = __webpack_public_path__ + "img/footer_logo_EBC.6a632d6c.svg";